import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../../data-services/auth.service';
import { MessageModule } from 'primeng/message';
import { FacebookLoginProvider, GoogleLoginProvider, GoogleSigninButtonModule, MicrosoftLoginProvider, SocialAuthService, SocialLoginModule, SocialUser } from '@abacritt/angularx-social-login';
import { MetaDataService } from '../../../data-services/metadata.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-preview',
  imports: [FormsModule, ReactiveFormsModule,MessageModule,SocialLoginModule,GoogleSigninButtonModule,FontAwesomeModule],
  templateUrl: '../ui/preview.component.html',
  styleUrl: '../ui/preview.component.css'
})
export class PreviewComponent implements OnInit {
  private readonly _authService = inject(AuthService);
  private readonly _metadataService = inject(MetaDataService)
  private readonly _socialAuthService = inject(SocialAuthService)
  GoogleLoginProvider = GoogleLoginProvider;
  user: SocialUser | undefined;
  loginProfile = new FormGroup({
    email: new FormControl(),
    password: new FormControl()
  })

  ngOnInit(): void {
    this._metadataService.constructMetaData({
      title: 'LRP Tickets | The portal to adventure |',
      description: 'Advanced preview of upcoming changes to LRP Tickets',
      url: 'https://preview.lrptickets.co.uk',
      image: 'https://preview.lrptickets.co.uk/ogCard.png'
    })
    this._socialAuthService.authState.subscribe((user) => {
      this.user = user;
      this._authService.socialLogin({
        email: user.email ?? '',
        firstname: user.firstName,
        surname: user.lastName,
        facebookId: user.provider === FacebookLoginProvider.PROVIDER_ID ? user.id : undefined,
        googleId: user.provider === GoogleLoginProvider.PROVIDER_ID ? user.id : undefined,
        microsoftId: user.provider === MicrosoftLoginProvider.PROVIDER_ID ? user.id : undefined,
        authToken: user.authToken
      })
    })
  }

  performLogin() {
    this._authService.login({
      email: this.loginProfile.value.email,
      password: this.loginProfile.value.password
    })
  }

    signInWithFB(): void {
      this._socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID);
    }
  
    signInWithMicrosoft(): void {
      this._socialAuthService.signIn(MicrosoftLoginProvider.PROVIDER_ID);
    }
  
    refreshGoogleToken(): void {
      this._socialAuthService.refreshAuthToken(GoogleLoginProvider.PROVIDER_ID);
    }
}
